import React from "react";
import { withRouter } from "react-router-dom";
import MainTitle from "./elements/MainTitle";
import ListPoints, { COLOR_WHITE } from './elements/ListPoints';
import PriceCard from './elements/PriceCard';
import { pricePerLibrary, helpCenterLink, placeholderMonthPrice } from '../../config/app';
import RoundedLink from '../elements/RoundedLink';
import CenteredContentWrapper from '../elements/CenteredContentWrapper';
import PropTypes from "prop-types";
import InternalLink from '../elements/InternalLink';

class PricingBlock extends React.PureComponent {
    libraryClickHandler = () => {
        const { history, isLogged } = this.props;

        if (!isLogged) {
            return history.push('/signup/catalog');
        }

        return history.push('/catalog');
    };
    render() {
        const {
            isUserVerified,
            isCustomerPortalPending,
            isPaymentResultPending,
            monthPlan,
            isPurchaseAvailable,
            subscriptionState,
            isLogged,
        } = this.props;

        return (
            <div className={'pricing'} id={'pricing'}>
                <div className={'wrapper'}>
                    <div className={'small-title'}>PRICING</div>

                    <MainTitle color={'white'} text={"Fresh Flow of Inspiration"}/>

                    <div className={'description'}>
                        Subscribe monthly to access all Capsules or purchase perpetual licenses for individual Capsules.
                    </div>

                    <div className={'price-items'}>
                        <div className={'left-block'}>
                            <ListPoints
                                color={COLOR_WHITE}
                                points={[
                                    'Unlimited download',
                                    'Get all Capsules, including future releases',
                                    'Cancel at any time',
                                    'DAW projects are compatible even if you cancel',
                                ]}/>
                            <InternalLink link={'/pricing'} className={'view-membership'}>
                                View membership
                            </InternalLink>
                        </div>

                        <div className={'cards-wrapper'}>
                            <div className={'subscription card-wrapper'}>
                                <PriceCard
                                    isLogged={isLogged}
                                    isLoading={isCustomerPortalPending || isPaymentResultPending || !monthPlan}
                                    isDisabled={!isUserVerified || !isPurchaseAvailable}
                                    isSubscription={true}
                                    subscriptionState={subscriptionState}
                                    styleType={'orange'}
                                    title={'Subscription'}
                                    payType={'Per month'}
                                    price={monthPlan ? monthPlan.price : placeholderMonthPrice}/>
                            </div>

                            <div className={'pay-per-use card-wrapper'}>
                                <PriceCard
                                    isLogged={isLogged}
                                    isLoading={false}
                                    isDisabled={!isUserVerified}
                                    isSubscription={false}
                                    subscriptionState={subscriptionState}
                                    styleType={'white'}
                                    title={'Pay Per Use'}
                                    payType={'Per library'}
                                    price={pricePerLibrary}/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={'support-block'}>
                    <CenteredContentWrapper>
                        <div className={'text'}>
                            <div className={'top'}>Have a specific question?</div>
                            <div className={'bottom'}>Check out our Support Center</div>
                        </div>

                        <div className={'link-wrapper'}>
                            <RoundedLink link={helpCenterLink} isBlank={true} text={'Support Center'} className={'button'}/>
                        </div>
                    </CenteredContentWrapper>
                </div>
            </div>
        );
    }
}

PricingBlock.propTypes = {
    checkout: PropTypes.func.isRequired,
    customerPortal: PropTypes.func.isRequired,
    focusVerificationPopup: PropTypes.func.isRequired,
    isLogged: PropTypes.bool.isRequired,
    isUserVerified: PropTypes.bool.isRequired,
    isSubscriptionActive: PropTypes.bool.isRequired,
    isCustomerPortalPending: PropTypes.bool.isRequired,
    isPaymentResultPending: PropTypes.bool.isRequired,
    isPurchaseAvailable: PropTypes.bool.isRequired,
    monthPlan: PropTypes.object,
    subscriptionState: PropTypes.string.isRequired,
};

export default withRouter(PricingBlock)
